import type { FC } from 'react';
import { Form, Field } from 'formik';
import { useTranslation } from 'react-i18next';

import Input from 'app/components/Input';
import Button from 'app/components/Button';
import sharedStyle from 'app/components/LoginLayout/sharedStyle.scss';
import { FormFieldWrapper } from 'app/components/LoginLayout';
import style from 'app/pages/SignupPage/style.scss';

interface Props {
  isValid: boolean;
  failed: boolean;
}

const ResetPasswordView: FC<Props> = ({ isValid, failed }) => {
  const { t } = useTranslation();

  return (
    <Form className={sharedStyle.form}>
      <div className={sharedStyle.fieldsContainer}>
        <Field
          name="password"
          component={FormFieldWrapper}
          fieldComponent={Input}
          label={t('reset_password-password')}
          type="password"
          error={failed}
          autoComplete="new-password"
        />
        <ul className={style.passwordRules}>
          <li>{t('signup-password_rules-line-1')}</li>
          <li>{t('signup-password_rules-line-2')}</li>
          <li>{t('signup-password_rules-line-3')}</li>
        </ul>
        <Field
          name="password_confirmation"
          component={FormFieldWrapper}
          fieldComponent={Input}
          label={t('reset_password-password_confirmation')}
          type="password"
          error={failed}
          autoComplete="new-password"
        />
      </div>
      <Button type="submit" disabled={!isValid} className={sharedStyle.submitButton}>
        {t('reset_password-submit')}
      </Button>
    </Form>
  );
};

ResetPasswordView.displayName = 'ResetPasswordView';

export default ResetPasswordView;
